import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=0669abc8&"
import script from "./ui-textarea.vue?vue&type=script&lang=ts&"
export * from "./ui-textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports